import { MainColors } from '../constants/Colors';
import FontSizes from '../constants/FontSizes';

export const defaultNavOptions = {
    headerStyle: {
        backgroundColor: MainColors.darkGray,
        shadowColor: 'transparent',
        borderBottomWidth: 0
    },
    headerTintColor: '#fff',
    headerTitleAlign: 'center',
    headerTitleStyle: {
        fontSize: FontSizes.medium,
        letterSpacing: 0.5,
    },
    headerBackTitleStyle: {
        fontWeight: '400',
        fontSize: FontSizes.medium
    },
    animationEnabled: false
}